import { api } from '../../../shared/services/api/client';

export const createApplePassWithQR = async (
    email,
    phone_number,
    name,
    birthDate,
    platform,
    optInMarketing,
    merchantId = null
) => {
    const payload = {
        email,
        phone_number,
        name,
        birthDate,
        platform: 'ios', // Always ios for Apple Wallet
        optInMarketing,
    };
    if (merchantId) {
        payload.merchantId = merchantId;
    }
    // Using versioned API endpoint
    return api.post('/passes/create', payload);
};

export const createApplePassWithLink = async (
    email,
    phone_number,
    name,
    birthDate,
    platform,
    optInMarketing,
    signupToken
) => {
    const payload = {
        email,
        phone_number,
        name,
        birthDate,
        platform: 'ios', // Always ios for Apple Wallet
        optInMarketing,
        signupToken,
    };
    // Using versioned API endpoint
    return api.post('/passes/create-with-link', payload);
};
